import React from 'react'
import { Form, Row, Col, DropdownButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'

// components
import { ArrowRight } from 'react-feather'

// definitions
import { StripeTaxRate, XeroTaxRate } from '../../../../../../back-end/utilities/apiDefinitions'
import { DetailedStripeOrgAccountXeroOrg, Error } from '../settings'

interface TaxRateMappingProps {
	stripeTaxRate: StripeTaxRate
	orgMapping: DetailedStripeOrgAccountXeroOrg
	xeroTaxRates: XeroTaxRate[]
	stripeOrgId: string
	handleTaxRateUpdate: (stripeOrgID: string, stripeTaxRateID: string, name: string, value: string) => void
	handleTaxRateAdd: (stripeOrgID: string, stripeTaxRateID: string, name: string, value: string) => void
	onlyShowErrors: boolean
	error?: Error
}

const TaxRateMapping = (props: TaxRateMappingProps) => {
	const taxRateMapping = props.orgMapping!.stripeTaxRateXeroTaxRates!.find((mapping) => mapping.stripeTaxRateID === props.stripeTaxRate.stripeTaxRateID)
	const selectedItem = props.xeroTaxRates.find((tr) => tr.xeroTaxRateID === taxRateMapping?.xeroTaxRateID)
	return (
		<>
			<Row
				key={props.stripeTaxRate.stripeTaxRateID}
				className={(props.error ? 'error ' : '') + (props.onlyShowErrors && !props.error ? 'd-none ' : '') + 'subsync-product-row'}
			>
				<Col
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyItems: 'center',
					}}
				>
					{props.stripeTaxRate.description ? (
						<OverlayTrigger
							placement={'left'}
							overlay={<Tooltip id={`${props.stripeTaxRate.stripeTaxRateID}-tooltip`}>{props.stripeTaxRate.description}</Tooltip>}
						>
							<div className="subsync-settings-label-small">{getStripeTaxRateInformation(props.stripeTaxRate)}</div>
						</OverlayTrigger>
					) : (
						<div className="subsync-settings-label-small">{getStripeTaxRateInformation(props.stripeTaxRate)}</div>
					)}
					{props.error ? <small className="error-message">{props.error.message}</small> : null}
				</Col>
				<Col
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<ArrowRight size="16" />
				</Col>
				<Col
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
					}}
				>
					<DropdownButton
						id={`${props.stripeOrgId}-mapping-taxrate-select`}
						title={taxRateMapping?.xeroTaxRateID === 'N/A' ? 'Not in use' : selectedItem?.name || 'Select Xero Tax Rate'}
						onSelect={(eventKey) =>
							taxRateMapping
								? props.handleTaxRateUpdate(props.stripeOrgId, props.stripeTaxRate.stripeTaxRateID!, 'xeroTaxRateID', eventKey!)
								: props.handleTaxRateAdd(props.stripeOrgId, props.stripeTaxRate.stripeTaxRateID!, 'xeroTaxRateID', eventKey!)
						}
					>
						{props.xeroTaxRates
							.filter(
								(tr) =>
									tr.canApplyToRevenue &&
									(!props.stripeTaxRate.stripeID?.startsWith('txr_') || tr.effectiveRate === props.stripeTaxRate.percentage)
							)
							.map((tr) => (
								<Dropdown.Item key={tr.xeroTaxRateID} eventKey={tr.xeroTaxRateID}>
									{tr.name} {tr.effectiveRate ? `(${(Number(tr.effectiveRate) * 100).toFixed(2)}%)` : ''}
								</Dropdown.Item>
							))}
						<Dropdown.Item eventKey="N/A">Not in use</Dropdown.Item>
					</DropdownButton>
				</Col>
			</Row>
		</>
	)
}

const getStripeTaxRateInformation = (stripeTaxRate: StripeTaxRate) => (
	<>
		{stripeTaxRate.name} {stripeTaxRate.state ? `${stripeTaxRate.state}, ` : ''}
		{stripeTaxRate.country}{' '}
		{stripeTaxRate.name !== 'No Stripe Tax Rate' && stripeTaxRate.percentage
			? `(${(Number(stripeTaxRate.percentage) * 100).toFixed(2)}%)${stripeTaxRate.inclusive ? ' inc' : stripeTaxRate.inclusive !== null ? ' exc' : ''}`
			: ''}
	</>
)

export { TaxRateMapping }
